import React from "react";
import Header from "../Header";
import BaseContainerDividingLineRHSSidebar from "../BaseContainerDividingLineRHSSidebar";
import EditProfileButton from "../EditProfileButton";
import ChangePlanButton from "../ChangePlanButton";
import PasswordAndSecurityButton from "../PasswordAndSecurityButton";
import NotificationsButton from "../NotificationsButton";
import rect6518 from "../../img/rectangle-6518@2x.svg";
import vect2 from "../../img/securityLogo.png"
import "./PasswordAndSecurityPage.css";

const PasswordAndSecurityPage = () => {

    return (
        <div className="container-center-horizontal">
            <div className="change-plan-home-page screen">
                <div className="flex-col">
                    <Header />
                    <div className="overlap-group2">
                        <BaseContainerDividingLineRHSSidebar />
                        <div className="rectangle-6452 border-1px-athens-gray-2"></div>
                        <div className="rectangle-6457 border-1px-athens-gray-2"></div>
                        <div className="profile nunito-bold-black-30px">Profile</div>
                        <div className="change-plan">
                            <div className="change-plan-1 nunito-bold-black-20px">Password and Security</div>
                        </div>
                        <img className="selected-icon" src={rect6518} />
                        <EditProfileButton />
                        <ChangePlanButton />
                        <PasswordAndSecurityButton className="nunito-bold-azure-radiance-14px" logo={vect2} />
                        <NotificationsButton />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PasswordAndSecurityPage;